import { ChartInfoKind } from '@frontend/chart/types';
import { TransactionTimerName } from '@frontend/transaction/types';
import { FormattedMessage } from 'react-intl';

import { INSIGHTS_GRID_CLASS_NAME, getInsightCardWidthClass } from '../insight-card-width';
import { InsightId } from '../insight-registry/insight-ids';
import { Last2WeeksPudoTransactionTimerActivityHourDayHeatmapChart } from './last-2-weeks-pudo-transaction-timer-activity-hour-day-heatmap-chart.component';
import { Last6MonthsPudoTransactionTimerActivityWeekdayHeatmapChart } from './last-6-months-pudo-transaction-timer-activity-weekday-heatmap-chart.component';
import { PudoCompartmentUsageBySizeDonutChart } from './pudo-compartment-usage-by-size-donut-chart.component';
import { PudoDailyTurnoverRateLineChart } from './pudo-daily-turnover-rate-line-chart.component';
import { PudoSlowestDropOffUsersList, PudoSlowestPickUpUsersList } from './pudo-transaction-timer-duration-by-user-list.component';
import { PudoTransactionsBySpotDonutChart } from './pudo-transaction-volume-by-spot-donut-chart.component';
import { PudoTransactionVolumeByReceiverList, PudoTransactionVolumeBySenderList } from './pudo-transaction-volume-by-user-list.component';
import { StalePudoTransactionsList } from './stale-pudo-transactions-list.component';

export interface PudoInsightsPageProps {
    accountId: string;
}

/** Standalone PuDo insights content — reusable outside Analytics (e.g. inside the PuDo app). */
export const PudoInsightsPage = ({ accountId }: PudoInsightsPageProps) => (
    <div className={INSIGHTS_GRID_CLASS_NAME}>
        <div className={getInsightCardWidthClass(2)}>
            <StalePudoTransactionsList
                insightId={InsightId.PUDO_STALE_DROP_OFFS}
                listId='insights-stale-drop-offs-list'
                accountId={accountId}
                infoKind={ChartInfoKind.STALE_DROP_OFF_TRANSACTIONS_LIST}
                timerName={TransactionTimerName.TRANSACTION_DROP_OFF_PENDING}
                title={
                    <FormattedMessage
                        id='platform.analytics.insights.stale-drop-offs.title'
                        description='Title for the stale drop-offs transaction list on the PuDo analytics insights tab'
                        defaultMessage='Stale drop-offs'
                    />
                }
            />
        </div>
        <div className={getInsightCardWidthClass(2)}>
            <StalePudoTransactionsList
                insightId={InsightId.PUDO_STALE_PICK_UPS}
                listId='insights-stale-pick-ups-list'
                accountId={accountId}
                infoKind={ChartInfoKind.STALE_PICK_UP_TRANSACTIONS_LIST}
                timerName={TransactionTimerName.TRANSACTION_PICK_UP_PENDING}
                title={
                    <FormattedMessage
                        id='platform.analytics.insights.stale-pick-ups.title'
                        description='Title for the stale pick-ups transaction list on the PuDo analytics insights tab'
                        defaultMessage='Stale pick-ups'
                    />
                }
            />
        </div>
        <PudoSlowestDropOffUsersList
            accountId={accountId}
            width={2}
        />
        <PudoSlowestPickUpUsersList
            accountId={accountId}
            width={2}
        />
        <PudoTransactionVolumeBySenderList
            accountId={accountId}
            width={2}
        />
        <PudoTransactionVolumeByReceiverList
            accountId={accountId}
            width={2}
        />
        <PudoDailyTurnoverRateLineChart
            accountId={accountId}
            width={2}
        />
        <PudoTransactionsBySpotDonutChart
            accountId={accountId}
            width={1}
        />
        <PudoCompartmentUsageBySizeDonutChart
            accountId={accountId}
            width={1}
        />
        <Last6MonthsPudoTransactionTimerActivityWeekdayHeatmapChart
            accountId={accountId}
            width={2}
        />
        <Last2WeeksPudoTransactionTimerActivityHourDayHeatmapChart
            accountId={accountId}
            width={2}
        />
    </div>
);
